import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=3822a194&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822a194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3822a194')) {
      api.createRecord('3822a194', component.options)
    } else {
      api.reload('3822a194', component.options)
    }
    module.hot.accept("./remark.vue?vue&type=template&id=3822a194&scoped=true&", function () {
      api.rerender('3822a194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/remark.vue"
export default component.exports